import map from 'lodash/map';

import type { Profile, ProfileSelect } from '@/features/Profile/types';

export const buildProfileSelectData = (data: Profile[]): ProfileSelect[] => {
  const result: ProfileSelect[] = [];

  map(data, (profile) => {
    result.push({
      ...profile,
      value: profile.id.toString(),
      label: profile.title,
      badge: profile.global ? 'DEMV' : undefined,
    });
  });

  return result;
};
